import { useShallowRouter } from '@components/Hooks/useRouter';
import {
  TEMPLATES_BI_CLICK_TYPES,
  useTemplatesBi,
} from '@components/Hooks/useTemplatesBi';
import { updateQueryParams } from '@utils/route';
import { Box, TextButton, Text } from '@wix/design-system';
import { useTranslation } from '@wix/fe-essentials-standalone/i18n';
import { ArrowRight } from '@wix/wix-ui-icons-common';
import { useCallback } from 'react';

const GalleryHeaderPopular = ({
  className,
  viewTextOverride,
}: {
  className?: string;
  viewTextOverride?: string;
}) => {
  const { t } = useTranslation();
  const { navigate, router } = useShallowRouter();
  const { logBiClick } = useTemplatesBi({});

  const onClick = useCallback(() => {
    logBiClick({ click_type: TEMPLATES_BI_CLICK_TYPES.viewAllTemplates });
    navigate(
      updateQueryParams({ sort: 'purchases' }, router, {
        all: true,
      }),
    );
  }, [navigate, router, logBiClick]);

  const text = viewTextOverride
    ? viewTextOverride
    : t('marketplace.templates-page.empty-state.gallery-header.view-all');

  return (
    <Box align="space-between" width="100%" className={className}>
      <Text weight="normal">
        {t('marketplace.templates-page.empty-state.gallery-header.title')}
      </Text>
      <TextButton onClick={onClick} suffixIcon={<ArrowRight />}>
        {text}
      </TextButton>
    </Box>
  );
};

export default GalleryHeaderPopular;
